import styled from "styled-components";

export const PauseAlert = styled.section`
  width: 100%;
  padding: 0.4rem 1.6rem;
  background-color: var(--red-light-100);
  color: var(--red-light-600);
  position: sticky;
  top: 0;
  z-index: 10;

  &,
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.6rem;
  }

  > div {
    p {
      padding: 0.2rem 0.8rem;
      border-radius: 0.4rem;
      border: 0.1rem solid currentColor;
      font-weight: bold;
    }

    span {
      font-size: 1.6rem;
      line-height: 2.4rem;
    }

    h3 {
      font-size: 2.4rem;
      line-height: 3.6rem;
      font-weight: bold;
      color: currentColor;
    }
  }
`;
